/* eslint-disable max-len */
import Decimal from 'decimal.js';

export const decimalSum = (number1, number2) => new Decimal(number1).plus(number2).toNumber();

export const decimalSub = (number1, number2) => new Decimal(number1).sub(number2).toNumber();

export const decimalMul = (number1, number2) => new Decimal(number1).mul(number2).toNumber();

export const decimalDiv = (number1, number2) => new Decimal(number1).div(number2).toNumber();

export const decimalPercentageOutOfAmount = (number1, number2) => new Decimal(number1).div(number2).mul(100).toNumber();

export const decimalIsEqual = (number1, number2) => new Decimal(number1).equals(number2);



// WEBPACK FOOTER //
// ./src/utils/decimal.js